import { createReducer, on } from '@ngrx/store';
import * as actions from './organization.actions';
import { ReducerFactory } from '../../../shared/store/common/reducer.factory';
import { createInitialOrganizationState } from './organization.state';

const factory = new ReducerFactory(actions as any);

export const organizationReducer = createReducer(
    createInitialOrganizationState(),
    on(
        actions.setActiveIntegrations,
        (state, newState) => ({ ...state, ...newState }),
    ),
);
